module.exports = __webpack_public_path__ + "img/image1.5168b601.jpg";